import type { CalendarsConfig } from "../Models/Domain";

import { fetchConfig } from "@/Services/TherapyApi/Calendars";
import CalendarConfigTransformer from "@/Modules/Transformers/Calendars/Config";

import useCalendarsStore from "../Store";

const fetchConfigActionHandler = async (): Promise<CalendarsConfig> => {
  const calendarsStore = useCalendarsStore();

  const config = await fetchConfig();

  calendarsStore.config = CalendarConfigTransformer.toDomain(config);

  return calendarsStore.config!;
};

export default fetchConfigActionHandler;
